module.exports = __webpack_public_path__ + "img/time-management-1.fa988a27.svg";